import React from "react";

function Block() {
  return (
    <div className="block lg:ps-40 lg:pb-10">
      <h6 className=" font-bold mb-5 text-xl">
        Sure, we’ve been around the block. We probably worked with the people
        who built it.
      </h6>
      <p className="text-gray-500 tracking-wider">
        Dui ut ornare lectus sit. Tincidunt lobortis feugiat vivamus at augue
        eget arcu. Vulputate mi sit amet mauris commodo quis imperdiet massa
        tincidunt. Sodales neque sodales ut etiam sit amet nisl. Blandit libero
        volutpat sed cras ornare arcu dui vivamus arcu. Luctus venenatis lectus
        magna fringilla urna porttitor rhoncus. Vitae suscipit tellus mauris a.
      </p>
    </div>
  );
}

export default Block;
